import { getFormatDate } from '../../../../../utils/Common';

/**
 * Formatea el nombre de la empresa
 */
export const formatCompanyName = (company) => {
  return company?.companyName || company?.NombreEmpresa || 'N/A';
};

/**
 * Formatea el nombre completo del contacto primario
 */
export const formatPrimaryContact = (company) => {
  const firstName = company?.contactPrimaryFirstName || company?.PrimerNombre || '';
  const lastName = company?.contactPrimaryLastName || company?.PrimerApellido || '';
  return [firstName, lastName].filter(Boolean).join(' ') || 'N/A';
};

/**
 * Formatea el email del contacto primario
 */
export const formatEmail = (company) => {
  return company?.contactPrimaryEmail || company?.Email || 'N/A';
};

/**
 * Formatea la fecha de creación de la empresa
 */
export const formatCreatedDate = (company) => {
  const date = company?.createdAt || company?.dateCreated || company?.createdDate;
  return date ? getFormatDate(date) : 'N/A';
};

/**
 * Formatea el código de la empresa
 */
export const formatCompanyCode = (company, companyId) => {
  // Priorizar boxitCompanyCode si es numérico, sino usar companyCode
  if (company?.boxitCompanyCode) {
    return company.boxitCompanyCode;
  }
  return company?.companyCode || company?.CodUser || companyId || 'N/A';
};

/**
 * Formatea el nombre completo de un cliente
 */
export const formatClientName = (client) => {
  const firstName = client?.firstName || client?.Nombre || '';
  const lastName = client?.lastName || client?.Apellidos || '';
  return [firstName, lastName].filter(Boolean).join(' ') || 'N/A';
};

/**
 * Formatea el nombre de la cuenta de un cliente
 */
export const formatAccountName = (client) => {
  const firstName = client?.accountFirstName || '';
  const lastName = client?.accountLastname || '';
  return [firstName, lastName].filter(Boolean).join(' ') || '-';
};

